/* src/app/modules/extractions/components/extraction-detail/extraction-detail.component.scss */
/*# sourceMappingURL=extraction-detail.component.css.map */
